import ArchiveIcon from '@mui/icons-material/Archive';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import WorkHistoryOutlinedIcon from '@mui/icons-material/WorkHistoryOutlined';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import OnedriveLogo from 'src/assets/storageIcons/onedrive.png';
import GoogleDriveLogo from 'src/assets/storageIcons/googledrive.png';
import DmonkLogo from 'src/assets/storageIcons/dmonk.png';
import DropboxLogo from 'src/assets/storageIcons/dropbox.png';
import config from 'src/config';

const flags = [
	{ value: 'important', label: 'Important', color: 'red', icon: <StarOutlineIcon style={{fontSize: '18px', color: 'red'}} />, iconSelected: <StarIcon style={{fontSize: '18px', color: 'red'}} /> },
	{ value: 'wip', label: 'WIP', color: 'orange', icon: <WorkHistoryOutlinedIcon style={{fontSize: '18px', color: 'orange'}} />, iconSelected: <WorkHistoryIcon style={{fontSize: '18px', color: 'orange'}} /> },
	{ value: 'final', label: 'Final', color: 'green', icon: <DoneIcon style={{fontSize: '18px', color: 'red'}} />, iconSelected: <DoneAllIcon style={{fontSize: '18px', color: 'green'}} /> },
	{ value: 'archive', label: 'Archive', color: 'grey', icon: <ArchiveOutlinedIcon style={{fontSize: '18px', color: 'grey'}} />, iconSelected: <ArchiveIcon style={{fontSize: '18px', color: 'grey'}} /> },
]

const services = [
    { value: config.FILE_SERVICES.ONEDRIVE, label: "OneDrive", icon: OnedriveLogo },
    { value: config.FILE_SERVICES.DROPBOX, label: "Dropbox", icon: DropboxLogo },
    { value: config.FILE_SERVICES.GOOGLEDRIVE, label: "Google Drive", icon: GoogleDriveLogo },
    { value: config.FILE_SERVICES.NEXTCLOUD, label: "dMonk", icon: DmonkLogo }
];
const recentOptions = [
    { value: "last_day", label: "1 day" },
    { value: "last_week", label: "1 week" },
    { value: "last_month", label: "1 month" }
];
const fileAgeOptions = [
{ value: "youngest_active", label: "Hot files" },
{ value: "oldest_active", label: "Cold files" },
// { value: "oldest_active,youngest_inactive", label: "Floating files" }
]

export default {
	flags,
	services,
	recentOptions,
	fileAgeOptions
}
